module.exports = __webpack_public_path__ + "media/images/participant-drop-call-715b5b1195309f8918705aa7daf022b7.svg";